import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "space-y-6" }
const _hoisted_2 = { class: "text-xl font-semibold text-gray-700" }
const _hoisted_3 = { class: "space-y-3" }
const _hoisted_4 = { class: "flex items-center space-x-3 w-full p-3 rounded-lg hover:bg-gray-50 cursor-pointer" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "text-gray-700" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.currentQuestion?.text), 1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentQuestion?.options, (option) => {
        return (_openBlock(), _createElementBlock("div", {
          key: option,
          class: "flex items-center"
        }, [
          _createElementVNode("label", _hoisted_4, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              value: option,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedAnswer) = $event)),
              class: "w-4 h-4 text-blue-600 focus:ring-blue-500"
            }, null, 8, _hoisted_5), [
              [_vModelRadio, _ctx.selectedAnswer]
            ]),
            _createElementVNode("span", _hoisted_6, _toDisplayString(option), 1)
          ])
        ]))
      }), 128))
    ])
  ]))
}